import { Button } from '@ixyberfree/ixybercomponents';
import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import Tabel, { IFilterItems } from 'components/MainControl/Table/Tabel';
import React from 'react';

interface IPropsRefDevice {
    refType: string;
    activeObject: any;
    closeCB?: Function;
    saveCB?: Function;
}

export const RefDevice: React.FC<IPropsRefDevice> = (props) => {
    let { refType, activeObject, closeCB, saveCB } = props;

    let [refObj, setRefObj] = React.useState<any[]>([]);
    let [selectRefObjPath, setSelectRefObjPath] = React.useState<any>();
    let [selectRefObjId, setSelectRefObjId] = React.useState<any>();

    React.useEffect(() => {
        refType !== undefined && getRefObj(refType);
    }, [refType]);

    const getRefObj = (type: string) => {
        hmiclientbase.SettingsGetIdsObjects({ type: type }).then((arrId: any) => {
            let tempRes: any[] = [];
            let count = 0;
            arrId.map((id: string) => {
                hmiclientbase.SettingsGetObjectDto(id).then((res: any) => {
                    if (activeObject.rpathcv == res.path) {
                        setSelectRefObjId(res.id);
                    }
                    tempRes.push(res);
                    ++count;
                    if (count === arrId.length) {
                        setRefObj(
                            tempRes.sort((a: any, b: any) => {
                                if (a.name != undefined) return a.name.localeCompare(b.name);
                            })
                        );
                    }
                });
            });
        });
    };

    const fi: IFilterItems = {
        name: {
            desc: 'name',
            filterList: new Map(),
            typeFilter: 'Input',
            sortFilter: { sortCol: 'default', sortItem: [], sortUp: true }
        },
        path: {
            desc: 'path',
            filterList: new Map(),
            typeFilter: 'Input',
            sortFilter: { sortCol: 'default', sortItem: [], sortUp: true }
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ overflow: 'auto' }}>
                    <div style={{ width: '300px' }}>
                        <Tabel
                            filterItems={fi}
                            initialcheckItem={selectRefObjId}
                            reports={refObj}
                            colList={['name', 'path']}
                            selectFindItem={(a: any, b: any, c: any) => {
                                console.log(a, b, c);
                            }}
                            OnClikcFilter={() => {}}
                            minWindth={300}
                            SelectedItem={(a: any, b: any, c: any) => {
                                c != 0 ? setSelectRefObjPath(refObj[b].path) : setSelectRefObjPath('');
                            }}
                            selectedOne={true}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                    <Button
                        text="Сохранить"
                        size="small"
                        styleType="filled"
                        onClick={() => saveCB && saveCB(selectRefObjPath)}
                    />
                    <div style={{ width: '1.8em' }}></div>
                    <Button text="Отмена" size="small" styleType="tinted" onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
